<template>
  <section
    v-if="hasPermission('view dashboard')"
    id="dashboard-business"
  >
    <b-row class="match-height">
      <!-- Dashboard 168 Statistics -->
      <b-col
        cols="12"
      >
        <dashboard168-widget />
      </b-col>
    </b-row>
    <b-row
      v-if="hasPermission('public dashboard')"
      class="match-height"
    >
      <!-- General Statistics -->
      <b-col
        xl="12"
        md="12"
      >
        <general-statistics-widget />
      </b-col>
    </b-row>

    <b-row
      v-if="hasPermission('public dashboard')"
      class="match-height"
    >
      <!-- Project Statistics -->
      <b-col
        lg="8"
        md="12"
      >
        <project-statistics-widget />
      </b-col>

      <!-- Employee Statistics -->
      <b-col
        lg="4"
        md="12"
      >
        <employee-statistics-widget />
      </b-col>
    </b-row>

    <b-row
      v-if="hasPermission('public dashboard')"
      class="match-height"
    >
      <!-- Financial Summary -->
      <b-col
        lg="8"
        md="12"
      >
        <financial-summary-widget />
      </b-col>

      <!-- Customer Statistics -->
      <b-col
        lg="4"
        md="12"
      >
        <customer-statistics-widget />
      </b-col>
    </b-row>

    <b-row
      v-if="hasPermission('public dashboard')"
      class="match-height"
    >
      <!-- Task Summary -->
      <b-col
        lg="8"
        md="12"
      >
        <task-summary-widget />
      </b-col>

      <!-- Recent Activities -->
      <b-col
        lg="4"
        md="12"
      >
        <recent-activities-widget />
      </b-col>
    </b-row>

  </section>
  <section v-else>
    <b-card>

      <b-card-text>
        ليس لديك صلاحية لعرض لوحة المعلومات
      </b-card-text>
    </b-card>
  </section>
</template>

<script>
import {
  BRow, BCol, BCard, BCardText,
} from 'bootstrap-vue'
import { mapGetters, mapActions } from 'vuex'
import GeneralStatisticsWidget from './business/widgets/GeneralStatisticsWidget.vue'
import ProjectStatisticsWidget from './business/widgets/ProjectStatisticsWidget.vue'
import FinancialSummaryWidget from './business/widgets/FinancialSummaryWidget.vue'
import TaskSummaryWidget from './business/widgets/TaskSummaryWidget.vue'
import EmployeeStatisticsWidget from './business/widgets/EmployeeStatisticsWidget.vue'
import CustomerStatisticsWidget from './business/widgets/CustomerStatisticsWidget.vue'
import RecentActivitiesWidget from './business/widgets/RecentActivitiesWidget.vue'
import Dashboard168Widget from './business/widgets/Dashboard168Widget.vue'

export default {
  name: 'Dashboard',
  components: {
    BRow,
    BCol,
    GeneralStatisticsWidget,
    ProjectStatisticsWidget,
    FinancialSummaryWidget,
    TaskSummaryWidget,
    EmployeeStatisticsWidget,
    CustomerStatisticsWidget,
    RecentActivitiesWidget,
    Dashboard168Widget,
    BCard,
    BCardText,
  },
  computed: {
    ...mapGetters('dashboard', ['overview', 'loading']),
  },
  methods: {
    ...mapActions('dashboard', ['fetchOverview']),
  },
  created() {
    // Fetch all dashboard data on mount
    this.fetchOverview().catch(error => {
      console.error('Error fetching dashboard overview:', error)
      this.$toast({
        component: () => import('@core/components/toastification/ToastificationContent.vue'),
        props: {
          title: 'خطأ',
          icon: 'AlertTriangleIcon',
          text: 'فشل في تحميل بيانات لوحة المعلومات',
          variant: 'danger',
        },
      })
    })
  },
}
</script>

<style lang="scss" scoped>
#dashboard-business {
  .match-height > [class*='col'] {
    display: flex;
    flex-flow: column;
  }
}
</style>
